import React from 'react';
import Card from '../../ui/Card';

export default function PresentationSection() {
  return (
    <Card variant="default" className="h-full w-full p-6 sm:p-8 flex flex-col justify-between shadow-acem-md hover:shadow-acem-lg transition-shadow">
      <div className="space-y-4">
        <div className="text-center sm:text-left border-b border-acem-border/50 pb-3">
          <h2 className="font-title text-xl sm:text-2xl font-extrabold text-acem-primary-dark tracking-tight">
            Qui sommes-nous ?
          </h2>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-5 sm:gap-6 text-center sm:text-left">
          <img
            src="/logo.png"
            alt="Logo ACEM Fès"
            className="w-28 sm:w-36 h-auto flex-shrink-0 drop-shadow-md"
          />
          <div className="flex-1 space-y-2.5">
            <p className="text-acem-text/90 leading-relaxed text-justify sm:text-left text-xs sm:text-sm">
              Fondée en 2002, l’<strong>Association des Comoriens Étudiant au Maroc (ACEM)</strong> section régionale de Fès est le pilier central de la communauté estudiantine comorienne dans la capitale spirituelle et universitaire du Royaume.
            </p>
            <p className="text-acem-text/80 leading-relaxed text-justify sm:text-left text-xs sm:text-sm">
              Ses missions consistent à faciliter l'intégration et l'accompagnement des nouveaux étudiants, promouvoir l'entraide académique et dynamiser la vie communautaire à travers des activités socio-culturelles et sportives.
            </p>
          </div>
        </div>
      </div>

      <div className="pt-4 mt-6 border-t border-acem-border/50 text-center">
        <span className="text-xs uppercase tracking-wider text-acem-muted font-semibold block mb-1">Notre Devise</span>
        <p className="font-bold text-acem-primary text-sm sm:text-base font-title tracking-wide">
          Égalité — Solidarité — Excellence
        </p>
      </div>
    </Card>
  );
}
